/* tslint:disable */
/* eslint-disable */
/**
 * Spotnana API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * This contains the enum mentioning the policy rule which was violated.
 * @export
 * @enum {string}
 */

export const PolicyPredicate = {
  UnknownPredicateString: 'UNKNOWN_PREDICATE_STRING',
  MaxFarePerTravellerViolation: 'MAX_FARE_PER_TRAVELLER_VIOLATION',
  FareMoreThanMinimum: 'FARE_MORE_THAN_MINIMUM',
  FareMoreThanMedian: 'FARE_MORE_THAN_MEDIAN',
  FareLessThanMedian: 'FARE_LESS_THAN_MEDIAN',
  FareMoreThanLlf: 'FARE_MORE_THAN_LLF',
  MaxFarePerTravellerViolationIncludingTax: 'MAX_FARE_PER_TRAVELLER_VIOLATION_INCLUDING_TAX',
  MaxFarePerTravellerViolationExcludingTax: 'MAX_FARE_PER_TRAVELLER_VIOLATION_EXCLUDING_TAX',
  HotelPaymentOptionsViolation: 'HOTEL_PAYMENT_OPTIONS_VIOLATION',
  RailBookingWindowGapViolation: 'RAIL_BOOKING_WINDOW_GAP_VIOLATION',
  RailTravelClassViolation: 'RAIL_TRAVEL_CLASS_VIOLATION',
  RailTicketRefundableViolation: 'RAIL_TICKET_REFUNDABLE_VIOLATION',
  RailMaxBookingPriceViolationIncludingTax: 'RAIL_MAX_BOOKING_PRICE_VIOLATION_INCLUDING_TAX',
  RailMaxBookingPriceViolationExcludingTax: 'RAIL_MAX_BOOKING_PRICE_VIOLATION_EXCLUDING_TAX',
  AirMaxPriceMoreThanLlfViolationIncludingTax: 'AIR_MAX_PRICE_MORE_THAN_LLF_VIOLATION_INCLUDING_TAX',
  AirMaxPriceMoreThanLlfViolationExcludingTax: 'AIR_MAX_PRICE_MORE_THAN_LLF_VIOLATION_EXCLUDING_TAX',
  HotelRestrictedKeywordsViolation: 'HOTEL_RESTRICTED_KEYWORDS_VIOLATION',
  RestrictedLocationViolation: 'RESTRICTED_LOCATION_VIOLATION',
  FlightAdvanceBookingWindowDomesticViolation: 'FLIGHT_ADVANCE_BOOKING_WINDOW_DOMESTIC_VIOLATION',
  FlightAdvanceBookingWindowInternationalViolation: 'FLIGHT_ADVANCE_BOOKING_WINDOW_INTERNATIONAL_VIOLATION',
  FlightAdvanceBookingWindowViolation: 'FLIGHT_ADVANCE_BOOKING_WINDOW_VIOLATION',
  ItineraryWithinEventTravelWindow: 'ITINERARY_WITHIN_EVENT_TRAVEL_WINDOW',
  HotelInAllowedHotelList: 'HOTEL_IN_ALLOWED_HOTEL_LIST',
  PaymentAccessViolation: 'PAYMENT_ACCESS_VIOLATION',
  AirportInAllowedAirportList: 'AIRPORT_IN_ALLOWED_AIRPORT_LIST',
  ItineraryTypeIsNotInAllowedBookingTypes: 'ITINERARY_TYPE_IS_NOT_IN_ALLOWED_BOOKING_TYPES',
  PaymentAirAddonViolation: 'PAYMENT_AIR_ADDON_VIOLATION',
} as const;

export type PolicyPredicate = (typeof PolicyPredicate)[keyof typeof PolicyPredicate];
